import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrainingComponent } from './training.component';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild()
  ],
  declarations: [TrainingComponent]
})
export class TrainingModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/training/training.module.ts